import { Grid, Typography } from '@mui/material';
import styles from './ProductShowcase.module.scss';
import ProductCard from '../../../../commons/components/ui/Cards/ProductCard/ProductCard';
import { showcaseProducts } from './constants';
import { useRef, useState, useEffect } from 'react';
import { DoubleArrowButtons } from '../../../../commons/components/ui';

const ProductShowcase = ({ page }) => {
  const showcaseRef = useRef(null);
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);
  const [cardWidth, setCardWidth] = useState(0);

  // Update scroll state
  const updateScrollState = () => {
    if (!showcaseRef.current) {
      return;
    }

    const { scrollLeft, scrollWidth, clientWidth } = showcaseRef.current;
    const firstCard = showcaseRef.current.querySelector(
      `.${styles.productsContainer} > div`
    );
    const newCardWidth = firstCard ? firstCard.offsetWidth : 0;
    const maxScroll = scrollWidth - clientWidth;

    const newCanScrollPrev = scrollLeft > 0;
    const newCanScrollNext = maxScroll > 0 && scrollLeft < maxScroll - 1;

    setCardWidth(newCardWidth);
    setCanScrollPrev(newCanScrollPrev);
    setCanScrollNext(newCanScrollNext);
  };

  // Scroll handlers
  const scrollPrev = () => {
    if (showcaseRef.current && cardWidth > 0) {
      showcaseRef.current.scrollBy({ left: -cardWidth, behavior: 'smooth' });
    }
  };

  const scrollNext = () => {
    if (showcaseRef.current && cardWidth > 0) {
      showcaseRef.current.scrollBy({ left: cardWidth, behavior: 'smooth' });
    }
  };

  // Set up listeners
  useEffect(() => {
    if (!showcaseRef.current) return;

    updateScrollState(); // Initial state

    const handleScroll = () => {
      updateScrollState();
    };

    const handleResize = () => {
      updateScrollState();
    };

    showcaseRef.current?.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    return () => {
      showcaseRef.current?.removeEventListener('scroll', handleScroll);
      window?.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className={styles.productShowcaseExtender} id="productShowCase">
      <div className={styles.productShowcaseContainer}>
        <Grid container sx={{ position: 'relative' }}>
          <div style={{ position: 'absolute', top: 0, right: 0, zIndex: 1 }}>
            <DoubleArrowButtons
              prevBtnHandler={scrollPrev}
              nextBtnHandler={scrollNext}
              prevDisabled={!canScrollPrev}
              nextDisabled={!canScrollNext}
              defaultActive="next"
            />
          </div>

          {page !== 'Error' ? (
            <Grid container className={styles.productsPitchContainer}>
              <Grid item xl={6} lg={12} md={8} sx={{ pb: 1 }}>
                <div className={styles.headingWrap}>
                  <Typography
                    variant="h1"
                    component="span"
                    color="primary.main"
                  >
                    The Power to Transform...{' '}
                  </Typography>
                  <div className={styles.headingContinued}>
                    <Typography
                      variant="h1"
                      component="span"
                      color="#2F6B01"
                      className={styles.noWrap}
                    >
                      Energy
                    </Typography>
                    <Typography
                      variant="h1"
                      component="span"
                      color="#532382"
                      className={styles.noWrap}
                    >
                      Anxiety
                    </Typography>
                    <Typography
                      variant="h1"
                      component="span"
                      color="#A8690D"
                      className={styles.noWrap}
                    >
                      Cognition
                    </Typography>
                    <Typography
                      variant="h1"
                      component="span"
                      color="#13586E"
                      className={styles.noWrap}
                    >
                      Pain
                    </Typography>
                    <Typography
                      variant="h1"
                      component="span"
                      color="#014572"
                      className={styles.noWrap}
                    >
                      Sleep
                    </Typography>
                    <Typography
                      variant="h1"
                      component="span"
                      className={styles.spacer}
                    >
                      &nbsp;
                    </Typography>
                  </div>
                </div>
              </Grid>
              <Grid item xl={6}></Grid>
              <Grid item xl={4} sx={{ pb: 2 }}></Grid>
            </Grid>
          ) : (
            ''
          )}
          <Grid
            container
            wrap="nowrap"
            className={styles.productsContainer}
            ref={showcaseRef}
            sx={{
              'overflowX': 'auto',
              'scrollSnapType': 'x mandatory',
              'WebkitOverflowScrolling': 'touch',
              'scrollbarWidth': 'none',
              '&::-webkit-scrollbar': { display: 'none' },
            }}
          >
            <Grid item xl={3} sx={{ scrollSnapAlign: 'start' }}>
              <ProductCard
                {...showcaseProducts.REL}
                packet={true}
                className={styles.leftPadding}
              />
            </Grid>
            <Grid item xl={3} sx={{ scrollSnapAlign: 'center' }}>
              <ProductCard {...showcaseProducts.TNK} badge="New arrival!" />
            </Grid>
            <Grid item xl={3} sx={{ scrollSnapAlign: 'center' }}>
              <ProductCard {...showcaseProducts.CLM} />
            </Grid>
            <Grid item xl={3} sx={{ scrollSnapAlign: 'center' }}>
              <ProductCard {...showcaseProducts.ENR} />
            </Grid>
            <Grid item xl={3} sx={{ scrollSnapAlign: 'center' }}>
              <ProductCard
                {...showcaseProducts.SLP}
                className={styles.rightPadding}
              />
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default ProductShowcase;
